import { FC } from 'react';
import TranslatedLabel from 'components/TranslatedLabel';

export const NavContentLabel: FC<{ translationKey?: string }> = ({ translationKey }) => (
	<TranslatedLabel i18nKey={`nav_items.${translationKey}`} />
);
